<template>
    <div
        class="full-width-image"
        :class="classImage"
    >
        <div class="full-width-image-wrapper">
            <ThLink
                v-if="data.link"
                v-bind="buttonBind"
            >
                <CmsImage
                    :data="data.image"
                    fit="cover"
                    :is-eager="hasEagerImage"
                />
            </ThLink>

            <CmsImage
                v-else
                :data="data.image"
                fit="cover"
                :is-eager="hasEagerImage"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, toRef } from 'vue'
import type { ComponentFullWidthImageFragment } from '@/graphql/api'
import { useCmsLink } from '@/components/cms'

import CmsImage from '@/components/cms/CmsImage.vue'
import ThLink from '@/components/ui/buttons/ThLink.vue'

const props = defineProps<{
    data: ComponentFullWidthImageFragment
    hasEagerImage?: boolean
}>()

const classImage = computed(() => ({
    [`${props.data.width.replace('_', '-').toLocaleLowerCase()}-width`]: true,
}))

const buttonBind = useCmsLink(toRef(() => props.data.link))
</script>

<style lang="scss" scoped>
.full-width-image {
    width: 100%;

    .full-width-image-wrapper {
        width: 100%;
        height: auto;

        @include min-width(640) {
            height: 350px;
        }

        @include min-width(1024) {
            height: 450px;
        }
    }

    &.extended-content-width {
        .full-width-image-wrapper {
            max-width: 1140px;
            height: auto;
            margin: 0 auto;

            @include min-width(640) {
                height: 450px;
            }

            @include min-width(1024) {
                height: 550px;
            }
        }
    }

    &.content-width {
        .full-width-image-wrapper {
            max-width: 680px;
            height: auto;
            margin: 0 auto;
        }
    }
}
</style>
